import React from "react";

const Start = () => (
  <div>
    <div className="App" />
  </div>
);

export default Start;
